document.addEventListener("DOMContentLoaded", function () {
 // Header Question
    document.querySelectorAll('.question_drop_wrap').forEach(function(element) {
        element.addEventListener("click", function() {
            this.classList.toggle('active');
            let que_nextElement = this.nextElementSibling;
            if (que_nextElement.classList.contains('open')) {
                que_nextElement.classList.remove('open');
            } else {
                que_nextElement.classList.add('open');
            }
        });
    });

    //Header megamenu left position start
    let main_parent_offset, parent_left_offset;
    document.querySelectorAll('.block__header--megamenu--wrapper.block__header-megamenu-left').forEach(function(element) {
        main_parent_offset = document.querySelector('.list-menu--inline').offsetLeft;
        parent_left_offset = element.closest('.block__header--megamenu-list').offsetLeft;
        element.style.left = (parent_left_offset - main_parent_offset) + 'px';
    });


    //Header megamenu open body class
    document.querySelectorAll(".block__header--megamenu-list").forEach(function(element) {
        element.addEventListener("mouseenter", function() {
                document.body.classList.add("header-menu-open");
        });
        element.addEventListener("mouseleave", function() {
                document.body.classList.remove("header-menu-open");
        });
    });

    // Header mobile menu close
    document.addEventListener('click', function(e) {
        if (e.target.closest('.menu-drawer-closebtn')) {
            document.querySelector('.menu-drawer-container summary.header__icon--summary').click();
        }
    });

    // Header mobile menu click on scroll to megamenu content
    document.addEventListener('click', function(e) {
        let element = e.target.closest('.menu-drawer .menu-drawer-megamenu-leftcontent .menu-drawer__menu-item[href="#"]');
        if (element) {
            e.preventDefault();
            let menutarget = element.getAttribute('data-menutarget');
            document.querySelector('#' + menutarget).scrollIntoView({ behavior: "smooth" });
        }
    });

    // Header mobile menu brand alphabet click
    document.addEventListener('click', function(e) {
        let element = e.target.closest('.menu-drawer .menudrawer-brandlist-leftcontent .block__header--megamenu-alphaitem');
        if (element) {
            e.preventDefault();
            let menutarget_brand = element.getAttribute('data-brandhref');
            document.querySelector('#' + menutarget_brand).scrollIntoView({ behavior: "smooth" });
        }
    });

    //mobile main tab menu click
    document.addEventListener('click', function(e) {
        let element = e.target.closest('.menu-drawer-megamenucategory-wrapper .header__top-menu-list .header__menu-item');
        if (element) {
            e.preventDefault();
            let current_topmenu = element.getAttribute('data-toplinkmenu');
            document.querySelectorAll('.menu-drawer-megamenucategory-wrapper .header__top-menu-list .header__menu-item').forEach(function(item) {
                item.classList.remove('mobile-headertopmenu-active');
            });
            element.classList.add('mobile-headertopmenu-active');
            if (current_topmenu == 'shop-by-category') {
                document.querySelector('.menudrawer-navigation-brandlist').style.display = 'none';
                document.querySelector('.menudrawer-navigation-brandlist').classList.remove('menudrawer-navigation-itemlistactive');
                document.querySelector('.menudrawer-navigation-categorylist').style.display = 'flex';
                document.querySelector('.menudrawer-navigation-categorylist').classList.add('menudrawer-navigation-itemlistactive');
            } else {
                document.querySelector('.menudrawer-navigation-categorylist').style.display = 'none';
                document.querySelector('.menudrawer-navigation-categorylist').classList.remove('menudrawer-navigation-itemlistactive');
                document.querySelector('.menudrawer-navigation-brandlist').style.display = 'flex';
                document.querySelector('.menudrawer-navigation-brandlist').classList.add('menudrawer-navigation-itemlistactive');
            }
        }
    });

    // Home Banner
    let mySwiperHomebanner = new Swiper('.block__home_banner-swiper', {
        loop: true,
        autoplayDisableOnInteraction: true,
        autoplay: {
            delay: 4000,
        },
        slidesPerView: 1,
        speed: 2000,
        pagination: {
            el: '.block__home_banner-swiper .swiper-pagination',
            clickable: 'true',
            type: 'bullets',
            renderBullet: function (index, className) {
                return '<span class="' + className + '">' + '<i></i>' + '<b></b>' + '</span>';
            },
        },
        navigation: {
            nextEl: '.block__home_banner-swiper .swiper-button-next',
            prevEl: '.block__home_banner-swiper .swiper-button-prev',
        }
    });

    // Video button play pause
    document.querySelectorAll('.section-banner-video').forEach((videoElement, index) => {
        const playPauseButton = document.querySelectorAll('.section-banner-video-icon')[index];
        if (videoElement && playPauseButton) {
            playPauseButton.addEventListener('click', () => {
                playPauseButton.classList.add('playing');
                videoElement.play();
                videoElement.setAttribute("controls","controls");
                videoElement.parentNode.classList.toggle("video-active");
                videoElement.style.objectFit = "contain";
                if (mySwiperHomebanner.autoplay) {
                    // Pause Swiper autoplay when the video plays
                    videoElement.addEventListener('play', function() {
                        mySwiperHomebanner.autoplay.stop();
                    });
                    // Resume Swiper autoplay when the video is paused
                    videoElement.addEventListener('pause', function() {
                        mySwiperHomebanner.autoplay.start();
                    }); 
                    // Also, stop autoplay when the video ends
                    videoElement.addEventListener('ended', function() {
                        mySwiperHomebanner.autoplay.start();
                    });
                }else{
                } 
            });
            videoElement.addEventListener('ended', () => {
                //videoElement.play();
            });
        }
    });

    // Home Most Popular Product
    const homrPopularList = document.querySelectorAll('.block__home_popular-swiper')
    homrPopularList && homrPopularList.forEach(homrPopularListAll => {
        new Swiper(homrPopularListAll, {
            slidesPerView: 6.5,
            // slidesPerView: 1.15,
            centeredSlides: true,
            spaceBetween: 20,
            loop: true,
            slidesPerGroup: 1,
            navigation: {
                nextEl: '.popular-next',
                prevEl: '.popular-prev',
            },
            breakpoints: {
                0: {
                    slidesPerView: 1,
                    spaceBetween: 20,
                    centeredSlides: false,
                    loop: false
                },
                370: {
                    slidesPerView: 2,
                    spaceBetween: 20,
                    centeredSlides: false,
                    loop: false
                },
                750: {
                    slidesPerView: 3.5,
                    spaceBetween: 20,
                    centeredSlides: false,
                    loop: false
                },
                991: {
                    slidesPerView: 4.5,
                    spaceBetween: 20,
                    centeredSlides: false,
                    loop: false
                },
                1200: {
                    slidesPerView: 6.5,
                    spaceBetween: 20,
                    centeredSlides: false,
                    loop: false
                }
            },
            lazy: {
                loadPrevNext: true, // Preload next/previous slides' images
                loadOnTransitionStart: true, // Load images when transition starts
            },
        });
    });

    // Home Home Collection Slider Product
    const homrCollecSliderList = document.querySelectorAll('.block__home_collection-slider-swiper')
    homrCollecSliderList && homrCollecSliderList.forEach((homrCollecSliderListAll, index) => {
        let nextelement = `.home-collection-next-${index + 1}`
        let prevelement = `.home-collection-prev-${index + 1}`

        new Swiper(homrCollecSliderListAll, {
            slidesPerView: 1,
            loop: true,
            navigation: {
                nextEl: nextelement,
                prevEl: prevelement,
            },
            breakpoints: {
                0: {
                    slidesPerView: 1,
                    loop: false
                }
            }
        });
    });

    // Home Shopper Review
    const homeReview = document.querySelectorAll('.block__owner-review-box-details')
    homeReview && homeReview.forEach(homeReviewlist => {
        new Swiper(homeReviewlist, {
            slidesPerView: 1,
            spaceBetween: 20,
            // autoplay: {
            //     delay: 2000,
            // },
            loop: true,
            navigation: {
                nextEl: '.home-review-next',
                prevEl: '.home-review-prev',
            },
            breakpoints: {
                350: {
                    slidesPerView: 1,
                    spaceBetween: 10,
                },
                750: {
                    slidesPerView: 1,
                    spaceBetween: 20,
                },
                989: {
                    slidesPerView: 2,
                    spaceBetween: 20,
                },
            }
        });
    });

    // Homepage banner list slider
    const homebannerlist = document.querySelector('.block__homepage-bannerlist-wrapper');
    const swiperHome = new Swiper(homebannerlist, {
        slidesPerView: 1,
        spaceBetween: 10,
        autoHeight: true,
        loop: true,
        speed: 2500,
        autoplay: {
            delay: 5000,
        },
        navigation: {
            nextEl: '.homepage-banner-next',
            prevEl: '.homepage-banner-prev',
        }
    });

    swiperHome.on('slideChangeTransitionStart', () => {
        swiperHome.updateAutoHeight();
    });

    // Home Tabing // Display the first tab content and add "active" class to the first tab
    if(document.querySelector('.block__home-trading-tab-content')){
        document.querySelector('.block__home-trading-tabs li a').classList.add("active");
        document.querySelector('.block__home-trading-tab-content').style.display = "block";
        // Add click event listener to all tab links
        document.querySelectorAll('.block__home-trading-tabs li a').forEach(function (tabLink) {
            tabLink.addEventListener("click", function (event) {
                event.preventDefault(); // Prevent default anchor behavior
                let id = this.getAttribute('data-tab');
                document.querySelectorAll('.block__home-trading-tabs li a').forEach(function (link) {
                    link.classList.remove("active");
                });
                document.querySelectorAll('.block__home-trading-tab-content').forEach(function (content) {
                    content.style.display = "none";
                });
                document.querySelector(id).style.display = "block";
                this.classList.add("active");
            });
        });
    }

    // Home Product Specs 
    document.addEventListener("click", function (event) {
        // Check if the clicked element has the class 'block__card_product-feature-head'
        if (event.target.closest('.block__card_product-feature-head')) {
            event.preventDefault();
            const featureHead = event.target.closest('.block__card_product-feature-head'); // Get the clicked element
            if (featureHead.classList.contains("show")) {
                featureHead.querySelector('span').textContent = 'Show Specs';
            } else {
                featureHead.querySelector('span').textContent = 'Hide Specs';
            }
            featureHead.classList.toggle("show");
            const productCardWrapper = featureHead.closest('.product-card-wrapper');
            if (productCardWrapper) {
                productCardWrapper.classList.toggle("show_feature");
            }
            const featureContent = featureHead.parentElement.querySelector(".block__card_product-feature-content");
            if (featureContent) {
                featureContent.classList.toggle("show");
            }
        }
    });

    // Home Most Poular Product Tabing
    // Display the first tab content and add "active" class to the first tab
    if(document.querySelector('.block__home-most-popular-tab-content')){
        document.querySelector('.block__home-most-popular-tab-content').style.display = "block";
        document.querySelector('.block__home-most-popular-tabs li a').classList.add("active");
        document.querySelectorAll('.block__home-most-popular-tabs li a').forEach(function (tabLink) {
            tabLink.addEventListener("click", function (event) {
                event.preventDefault(); // Prevent default anchor behavior
                let id = this.getAttribute('data-tab');
                document.querySelectorAll('.block__home-most-popular-tabs li a').forEach(function (link) {
                    link.classList.remove("active");
                });
                document.querySelectorAll('.block__home-most-popular-tab-content').forEach(function (content) {
                    content.style.display = "none";
                });
                document.querySelector(id).style.display = "block";
                this.classList.add("active");
            });
        });
    }
   

    // Footer Infinate Scroll
    new Swiper('.new-footer-service-swiper', {
        spaceBetween: 0,
        centeredSlides: true,
        speed: 4000,
        autoplay: {
          delay: 1,
        },
        loop: true,
        slidesPerView:'auto',
        allowTouchMove: false,
        disableOnInteraction: true
    });

    // Open shopify inbox widget on click "chat with us" button
    const openChatButtonAll = document.querySelectorAll(".block__chat-shopifyinbox");
    // Add click event listener to the button
    openChatButtonAll.forEach(openChatButton => {
      openChatButton.addEventListener("click", function() {
          const chatContainer = document.getElementById("shopify-chat");
          if (chatContainer) {
              const chatToggleButton = chatContainer.querySelector("inbox-online-store-chat").shadowRoot.querySelector(".chat-toggle");
              if (chatToggleButton) {
                  chatToggleButton.click();
              } else {
              }
          } else {
          }
      });
    });

    // shopify chat button close on document click
    document.addEventListener('click', function (event) {
        // Check if the clicked element is not inside the popup or its toggle button
        const chatContainer = document.getElementById("shopify-chat");
        if(chatContainer){
            const chatToggleButton = chatContainer ? chatContainer.querySelector("inbox-online-store-chat").shadowRoot.querySelector(".chat-app--close-button") : null;
            const chatopentbn = chatContainer.querySelector("inbox-online-store-chat");
            if (!$(event.target).closest('.block__chat-shopifyinbox').length) {
                if (!$(event.target).closest(chatopentbn).length) {
                    // Close the popup
                    if (chatToggleButton) {
                        chatToggleButton.click();
                    }
                }
            }
        }
    });

    // Get the current page path
    const currentPagePath = window.location.pathname;

    // Product page tab section
    if (!["/pages/datasheets-manuals", "/pages/manuals"].includes(currentPagePath)) {
        document.querySelectorAll('.block__producttabs-wrapper .block__product-tabheading').forEach(function(element) {
            element.addEventListener('click', function(e) {
                e.preventDefault();
                const current_producttab_val = this.getAttribute('data-producttabhead');
                document.querySelectorAll('.block__product-tabheading').forEach(function(item) {
                    item.classList.remove('block__product-tabactive');
                });
                this.classList.add('block__product-tabactive');
                document.querySelectorAll('.block__producttab-contentwrap .block__producttab-txtcontent').forEach(function(content) {
                    content.classList.remove('block__product-tabcontentactive');
                });
                document.querySelector('.block__producttab-contentwrap .block__producttab-txtcontent[data-producttabcontent="' + current_producttab_val + '"]').classList.add('block__product-tabcontentactive');
            });
        });
    }   

    // Customer register form tag add
    if(document.getElementById('create_customer')){
        document.getElementById('create_customer').addEventListener('submit', function(event) {
            let country = document.getElementById('RegisterForm-Country').value;
            let state = document.getElementById('RegisterForm-State').value;
            let city = document.getElementById('RegisterForm-City').value;
            let zip = document.getElementById('RegisterForm-Zipcode').value;
        
            let all_join_tags = ['country_'+country, 'state_'+state, 'city_'+city, 'zipcode_'+zip].join(', ');
        
            document.getElementById('customer_tags').value = all_join_tags;
        });
    }else{}

    // product card quick view on quote btn
    // Add click event listener to all elements with the class 'product-requestquote-quickview'
    document.querySelectorAll('.product-requestquote-quickview').forEach(function (button) {
        button.addEventListener("click", function () {
            const currentButton = this;
            currentButton.classList.add('loading');
            currentButton.setAttribute('aria-disabled', true);
            const spinner = currentButton.querySelector('.loading__spinner');
            if (spinner) {
                spinner.classList.remove('hidden');
            }
            const quickAddButton = currentButton.closest('.quick-viewcontent')
                ?.querySelector('modal-opener .quick-add__submit');
            if (quickAddButton) {
                quickAddButton.click();
            }
            document.querySelectorAll('.quick-add__submit').forEach(function (submitButton) {
                submitButton.classList.remove('loading');
                submitButton.removeAttribute('aria-disabled');
            });
            setTimeout(function () {
                currentButton.classList.remove('loading');
                currentButton.setAttribute('aria-disabled', false);
                if (spinner) {
                    spinner.classList.add('hidden');
                }
            }, 3000);
        });
    });

    // Header shop by brand alphabet wise redirection
    const megamenuAlphabet = document.querySelectorAll('.block__header-shopredirectlink');
    megamenuAlphabet.forEach(function(alpha) {
        alpha.addEventListener('click', function(e) {
            e.preventDefault();
            let currentHref = this.getAttribute('href'); 
            const section = this.getAttribute('data-section');
            // Redirect to the destination page with the data attribute as a query parameter
            window.location.href = `${currentHref}?scroll-target=${section}`;
        });
    });

    //  RMA fORM PAGE JS
    let forminterval = setInterval(function() {
        if(document.querySelector("[data-forms-id='forms-root-273566']")){
            const RMAformID = document.querySelector("[data-forms-id='forms-root-273566']");
            const appformContainer = RMAformID.querySelector("#app-embed");
            if(appformContainer){
                const appshadowformcontainer = appformContainer.shadowRoot.querySelectorAll("._formContainer_stahb_30 ._formInputFieldLabel_1ydxd_37");
                appshadowformcontainer.forEach(appshadowformlabel => {
                    if (appshadowformlabel) {
                        // Close the popup
                        appshadowformlabel.style.top = "18px";
                        clearInterval(forminterval);
                    }
                });
            }
        }
    }, 1000);

    let quantityInputs = document.querySelectorAll('.quantity__input');
    quantityInputs.forEach(function(input) {
        input.addEventListener('blur', function() {
            var minValue = parseInt(input.getAttribute('min'), 10);
            var currentValue = parseInt(input.value, 10);

            if (currentValue < minValue) {
                input.value = minValue;
            }
        });
    });

    // Homepage Request quote button on open quote basket
        document.querySelectorAll('.request-quote-basket-open').forEach(function (button) {
            button.addEventListener("click", function () {
                const quotePopup = document.querySelector('quote-popup.quotepopup-section');
                if (quotePopup) {
                    quotePopup.classList.add('quoteopen');
                    quotePopup.style.display = 'flex';
                    document.body.classList.add('small-quotepopup-open');
                }
            });
        });
    

});

$(document).ready(function () {

    // Header shop brand menu see all
    $(".block__header--megamenu-collectionitemwrap").each(function(){
        let items = $(this).find(".block__header--megamenu-collectiontitle:not(.block__header--megamenu-collectionall)");
        let numToShow = 6;  
        let numMore = 100;   
        items.slice(0, numToShow).addClass('showing');
    });

    $(".block__input-product-search").on("keyup", function () {
        let key_value = $(this).val().toLowerCase(),
            matchingItems = 0;
        $(".block__header--megamenu-collectionitemwrap").each(function () {
            let collectiontext = $(this).text().toLowerCase(),
                match = collectiontext.indexOf(key_value) > -1;
            $(this).toggle(match), match && matchingItems++;
        });
        if(key_value === ""){
            $('.header__top-menu-wrap .block__header--megamenu-collectionitemwrap').each(function (index) {                   
                if(index >= 14){
                    $(this).fadeOut("slow").addClass("hide");
                }else{
                    $(this).fadeIn("slow").removeClass("hide");
                }
            })
        }else{}
    });

    // Footer Mobile
    if ($(window).width() <= 749) {
        $('.block__new-footer-menu-listing-heading').on("click", function(){
            if($(this).hasClass('active')){
                $(this).removeClass('active');
                $(this).next().slideUp();
            } else {
                $('.block__new-footer-menu-listing-heading').removeClass('active');
                $('.footer-block__details-content').slideUp();
                $(this).addClass('active');
                $(this).next().slideDown();
            }    
        });
    }

    // Aboutus page leadership readmore-less js
    function AddReadMore() {
        let carLmt = 300;
        const readMoreTxt = " Read More";
        const readLessTxt = " Read Less";

        $(".block__aboutus-leader-biocontent").each(function () {
        if ($(this).find(".first-section").length)
            return;

        const allstr = $(this).text();
        if (allstr.length > carLmt) {
            let firstSet = allstr.substring(0, carLmt);
            let secdHalf = allstr.substring(carLmt, allstr.length);
            let strtoadd = firstSet + "<span class='second-section'>" + secdHalf + "</span><span class='read-more'  title='Click to Show More'>" + readMoreTxt + "</span><span class='read-less' title='Click to Show Less'>" + readLessTxt + "</span>";
            $(this).html(strtoadd);
        }
        });

        $(document).on("click", ".read-more,.read-less", function () {
            $(this).closest(".block__aboutus-leader-biocontent").toggleClass("show-less-content show-more-content");
        });
    }
    AddReadMore();

    //Aboutus page leadership mobile js
    $('.block__aboutus-leader-itemwrap').click(function(){
        $('.block__aboutus-leader-itemwrap').not($(this)).removeClass('leaderitem-active');
        if($(this).hasClass('leaderitem-active')){
          $(this).removeClass('leaderitem-active');  
        }else{
          $(this).addClass('leaderitem-active');
        }
        $('.block__aboutus-leader-itemhover').not($(this).siblings('.block__aboutus-leader-itemhover')).slideUp(500);
        $(this).next().slideToggle(500);
    });

     // Faq page accordation
     $('.block__faq__question').click(function(){
        $('.block__faq__question').not($(this)).removeClass('faq-is-active');
        if($(this).hasClass('faq-is-active')){
          $(this).removeClass('faq-is-active');  
        }else{
          $(this).addClass('faq-is-active');
        }
        $('.block__faq__answer').not($(this).siblings('.block__faq__answer')).slideUp(500);
        $(this).next().slideToggle(500);
      });

      $('.block__faq-tabtype:not(.block__faqtab-contactitem)').click(function(e){
        e.preventDefault();
        let current_faq_val = $(this).attr('data-faqtabtype');
        $('.block__faq-tabtype').removeClass('block__faqtab-active');
        $(this).addClass('block__faqtab-active');
        $('html, body').animate({
          scrollTop: $('.block__faq-queans-wrapper[data-faqtabcontent="'+current_faq_val+'"]').offset().top - 200
        }, 1000);
      });

    // cart
    $('.block__cart_note-wrapper .cart_not_icon_wrap').on("click", function(){
        $(this).next().slideToggle('slow');
    });
    
    // Mobile Cart icon
    $('#cart-icon-bubble1').on("click",function(e){
        e.preventDefault();
        document.getElementById("cart-icon-bubble").click();
    });
     
    // sell Equipment FAQ
    $('.block__sell_equip_faq-wrap').first().find('.block__sell_equip_faq-header').addClass('open');
    $('.block__sell_equip_faq-wrap').first().find('.block__sell_equip_faq-content').slideDown('slow');
    $('.block__sell_equip_faq-header').on("click", function(){
        if($(this).hasClass('open')){
            $(this).removeClass('open');
            $(this).next().slideUp('slow');
        } else {
            $('.block__sell_equip_faq-header').removeClass('open');
            $('.block__sell_equip_faq-content').slideUp('slow');
            $(this).addClass('open');
            $(this).next().slideDown('slow');
        }
    });

    // Login page 
    $(".show_password").on("change", function(e){
        if(e.currentTarget.checked){
            $('.password_input').attr("type", "text");
        } else {
            $('.password_input').attr("type", "password");        
        }
    });

    // My Account
    let currentTab = localStorage.getItem('account_current_tab');
    if(currentTab){
        if(document.querySelectorAll(`.main_account-tabitem[data-accounttab="${currentTab}"]`).length > 0){
            const firstEle = document.querySelectorAll(`.main_account-tabitem[data-accounttab="${currentTab}"]`)[0];
            const innerEle = firstEle.querySelector('a').innerText;
            $('.block__pagebanner-breadcrumb-heading').text(innerEle);
            $('.main_account-tab-mobilefilter .current_tab').text(innerEle);
            $(`.main_account-tabitem[data-accounttab="${currentTab}"]`).addClass("main_accounttab-active");
            $(`.main_account_tabcontentwrap[data-accounttabcontent="${currentTab}"]`).addClass("main_accounttabcontent-active");
        }else{}
        
    } else {
        $('.main_account-tab-mobilefilter .current_tab').text('');
        const currentText = $('.block__mobile_myaccount_tab .main_account-tablist .main_account-tabitem:first-child').find('a').text();
        $('.main_account-tab-mobilefilter .current_tab').text(currentText);
        $('.main_account-tablist .main_account-tabitem:first-child').addClass("main_accounttab-active");
        $('.main_account_tabcontentwrapper .main_account_tabcontentwrap:first-child').addClass("main_accounttabcontent-active");
    }

    $(".main_account-tabitem:not(.main_account-tabitemlogout)").on("click", function(e){
        let currentTab = $(this).attr("data-accounttab");
        localStorage.setItem("account_current_tab", currentTab);
        $(".main_account-tabitem").removeClass('main_accounttab-active');
        $(".main_account_tabcontentwrap").removeClass("main_accounttabcontent-active");
            
        $(this).addClass("main_accounttab-active")
        $(`.main_account_tabcontentwrap[data-accounttabcontent="${currentTab}"]`).addClass("main_accounttabcontent-active");
        const currentText = $(this).find('a').text();
        $('.block__pagebanner-breadcrumb-heading').text(currentText);
        $('.main_account-tab-mobilefilter .current_tab').text(currentText);
        if($(window).width() < 749){
            $('.main_account-tablist').slideUp();
        }
    });

    if($(window).width() < 749){
        $('.main_account-tablist').slideUp();
        $('.main_account-tab-mobilefilter').on("click", function(){
            $(this).toggleClass("tab-filter-open");
            $('.main_account-tablist').slideToggle('slow');
        });
    }

    // Manage Order
    $(".main_account-manageorder").on("click", function(){
        $(this).parents('.main_account_orderhistory').toggleClass('is-open');
    });

    // Product category lookup page accordation

    $(".product-category-lookup-search").on("keyup", function () {
        let search_keyvalue = $(this).val().toLowerCase(),
            matchingItems = 0;
        $(".product-category-lookup-inner-itemwrap").each(function () {
            let category_itemtext = $(this).find('.product-category-lookup-inner-itemheader').text().toLowerCase(),
                category_match = category_itemtext.indexOf(search_keyvalue) > -1;
            $(this).toggle(category_match), category_match && matchingItems++;
        });
        $(".product-category-lookup-mainaccoradtion").each(function () {
            let category_accordation_text = $(this).find('.product-category-lookup-inner-itemheader').text().toLowerCase(),
            category_accordation_match = category_accordation_text.indexOf(search_keyvalue) > -1;
            $(this).toggle(category_accordation_match), category_accordation_match && matchingItems++;
            let accordation_alpha;
            $('.product-category-lookup-listitem:not(.enable-listitem)').addClass('disable-listitem');
            if(category_accordation_match){
                accordation_alpha = $(this).find('.product-category-lookup-accordation-header').text().toLowerCase().trim();
                $('.product-category-lookup-alphaitem[data-brand="'+accordation_alpha+'"]').parents('.product-category-lookup-listitem').removeClass('disable-listitem').addClass('enable-listitem');
            }else{}
            
        });
        if(search_keyvalue === ""){
            $('.product-category-lookup-mainaccoradtion, .product-category-lookup-inner-itemwrap').each(function (index) {                   
                    $(this).fadeIn("slow").removeClass("hide");
                    $('.product-category-lookup-listitem').removeClass('disable-listitem').removeClass('enable-listitem');
            })
        }else{}
    });

    $('.product-category-lookup-inner-itemheaderlink').click(function(e){
        e.stopPropagation();
    });

    $('.product-category-lookup-accordation-header').click(function(){
        let accordation_alpha_header = $(this).text().toLowerCase().trim();
        if($(this).parent('.product-category-lookup-maincategory').hasClass('active-category')){
            $(this).parent('.product-category-lookup-maincategory').removeClass('active-category');  
            $('.product-category-lookup-alphaitem[data-brand="'+accordation_alpha_header+'"]').parents('.product-category-lookup-listitem').removeClass('product-category-lookup-listitem-active');
        }else{
            $(this).parent('.product-category-lookup-maincategory').addClass('active-category');
            $('.product-category-lookup-alphaitem[data-brand="'+accordation_alpha_header+'"]').parents('.product-category-lookup-listitem').addClass('product-category-lookup-listitem-active');
        }
        $(this).next().slideToggle(500);
    });

    $('.product-category-lookup-inner-itemheader').click(function(){
        $('.product-category-lookup-inner-itemheader').not($(this)).parent('.product-category-lookup-inner-itemwrap').removeClass('active-innercategory');
        if($(this).parent('.product-category-lookup-inner-itemwrap').hasClass('active-innercategory')){
            $(this).parent('.product-category-lookup-inner-itemwrap').removeClass('active-innercategory');  
        }else{
            $(this).parent('.product-category-lookup-inner-itemwrap').addClass('active-innercategory');
        }
        $('.product-category-lookup-inner-itemcontent').not($(this).siblings('.product-category-lookup-inner-itemcontent')).slideUp(500);
        $(this).next().slideToggle(500);
    });

    $('.product-category-lookup-listitem .product-category-lookup-alphaitem').bind('click', function(e) {
        e.preventDefault();
        let _this = $(this); 
        let current_alphaval = _this.attr('scroll-trigger'); 
        let scrollTarget = $('*[scroll-target='+current_alphaval+']');
        $('.product-category-lookup-listitem').removeClass('product-category-lookup-listitem-active');
        $(this).parents('.product-category-lookup-listitem').addClass('product-category-lookup-listitem-active');
        $('html, body').stop().animate({
            scrollTop: scrollTarget.offset().top - 160
        }, 600 );
        return false; 
    });

});

$(document).on("click", function(event){
    let $trigger = $(".question_drop_wrapper");
    if($trigger !== event.target && !$trigger.has(event.target).length){
        $(".question_drop_wrap").removeClass("active");
        $(".question_dropdown_wrap").removeClass("open");
    }            
});

// shopify chatbox on body scroll off
function adjustchatscroll() {
    setTimeout(function(){
        let livechatContainer = document.getElementById("shopify-chat");
            let livechatscrollcontent = livechatContainer.querySelector("inbox-online-store-chat").shadowRoot.querySelector(".chat-messages__list");
            if(livechatscrollcontent){
                $(livechatscrollcontent).on( 'mousewheel DOMMouseScroll', function ( e ) {
                    var e0 = e.originalEvent,
                        delta = e0.wheelDelta || -e0.detail;
                    this.scrollTop += ( delta < 0 ? 1 : -1 ) * 30;
                    e.preventDefault();
                });
            }else{
                $(livechatContainer).on( 'mousewheel DOMMouseScroll', function ( e ) {
                    var e0 = e.originalEvent,
                        delta = e0.wheelDelta || -e0.detail;
                    this.scrollTop += ( delta < 0 ? 1 : -1 ) * 30;
                    e.preventDefault();
                });
            }

            if(window.innerWidth > 989){
                $('.block__header--megamenu--innerwrap').on( 'mousewheel DOMMouseScroll', function ( e ) {
                    var e0 = e.originalEvent,
                        delta = e0.wheelDelta || -e0.detail;
                    this.scrollTop += ( delta < 0 ? 1 : -1 ) * 30;
                    e.preventDefault();
                });
            }else{}
            
    },1000);
}

$(window).on('load', adjustchatscroll);
$(window).on('resize', adjustchatscroll);

$(window).on('load', function() {
    //document.querySelector('.main-video-div #globe').style.display = 'none';
    //document.querySelector('.main-video-div #globe-video').style.display = 'block';
  })


//   Loyalty account on points popup body class
$(document).on('click', '.lion-rule-item__actions .lion-action-button', function() {
    document.body.classList.add('loyalty-popup');
});
$(document).on('click', '.lion-modal-and-screen .lion-modal__header .lion-modal__close-button, .lion-modal-and-screen .lion-referral-widget-modal__close-button', function() {
    document.body.classList.remove('loyalty-popup');
});

$(document).click(function(e) {
    // Check if the click is outside the modal
    if (!$(e.target).closest("#loyaltylion .lion-modal").length && !$(e.target).closest(".lion-referral-widget-modal").length) {
        if ($('.lion-modal').is(':visible') || $('.lion-referral-widget-modal').is(':visible')) {
            let modalCloseButton = document.querySelector('.lion-modal-and-screen .lion-modal__header .lion-modal__close-button');
            if(modalCloseButton) {
                modalCloseButton.click();
            }
            let referralCloseButton = document.querySelector('.lion-modal-and-screen .lion-referral-widget-modal__close-button');
            if(referralCloseButton) {
                referralCloseButton.click();
            }
        }
    }
});
// collection page FAQ
document.addEventListener("DOMContentLoaded", function () {
    // Open the first FAQ item by default
    let firstFaq = document.querySelector('.block__collection_faq-wrap');
    if (firstFaq) {
        firstFaq.querySelector('.block__collection_faq-header').classList.add('open');
        let firstContent = firstFaq.querySelector('.block__collection_faq-content');
        if (firstContent) {
            firstContent.style.display = "block";
        }
    }

    // Add click event listener to all FAQ headers
    document.querySelectorAll('.block__collection_faq-header').forEach(header => {
        header.addEventListener("click", function () {
            let content = this.nextElementSibling;

            if (this.classList.contains('open')) {
                this.classList.remove('open');
                content.style.display = "none";
            } else {
                // Close all other FAQs
                document.querySelectorAll('.block__collection_faq-header').forEach(h => h.classList.remove('open'));
                document.querySelectorAll('.block__collection_faq-content').forEach(c => c.style.display = "none");

                // Open the clicked FAQ
                this.classList.add('open');
                content.style.display = "block";
            }
        });
    });
});

function initCartImageZoom() {
  const drawer = document.querySelector('#CartDrawer');
  if (!drawer) return;

  drawer.removeEventListener('click', drawer._zoomListener);

  drawer._zoomListener = function(e) {
    const img = e.target.closest('.cart-item__media .cart-item__image');
    if (!img) return;

    const imgSrc = img.src.replace('_medium', '_1024x1024');

    const modal = document.createElement('div');
    modal.classList.add('zoom-modal');
    modal.innerHTML = `
      <div class="zoom-overlay">
        <img src="${imgSrc}" class="zoomed-image" />
        <span class="close-btn">&times;</span>
      </div>
    `;

    document.body.appendChild(modal);

    modal.querySelector('.close-btn').addEventListener('click', () => modal.remove());

    modal.querySelector('.zoom-overlay').addEventListener('click', (ev) => {
      if (ev.target === modal.querySelector('.zoom-overlay')) modal.remove();
    });
  };

  drawer.addEventListener('click', drawer._zoomListener);
}

initCartImageZoom();